import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-sm-switch',
    templateUrl: './sm-switch.component.html',
    styleUrls: ['./sm-switch.component.scss'],
    standalone: false
})
  export class SmSwitchComponent {

    @Input()
    textFalse = "";
    @Input()
    textTrue = "";
    @Input()
    value = true;
    @Output()
    valueChange = new EventEmitter<boolean>();

    switch(): void {
        this.valueChange.emit(this.value);
    }

}
